// extracted by mini-css-extract-plugin
module.exports = {"ticketList":"TicketList_ticketList___k7m9"};